export const DOCUMENT_TYPE_CLOTHING_PRODUCT = 'commerce.clothingProduct';
export const DOCUMENT_TYPE_CUSTOM_CLOTHING_PRODUCT = 'commerce.customClothingProduct';
export const OBJECT_TYPE_CLOTHING_VARIANT = 'commerce.clothingVariant';
export const OBJECT_TYPE_CLOTHING_PRINT_OPTION_GROUP = 'commerce.clothingPrintOptionGroup';

/**
 * @deprecated Use OBJECT_TYPE_CLOTHING_VARIANT instead. This variant typename is deprecated in favour of OBJECT_TYPE_CLOTHING_VARIANT and is only kept for backward compatibility.
 */
export const OBJECT_TYPE_CLOTHING_VARIANT_LEGACY = 'clothingVariant' as const;
